// extracted by mini-css-extract-plugin
export var label = "_qr-0";
export var link = "_qr-1";